<template>
  <div class="login-container">
    <el-form ref="register" :model="registerData" class="login-form" auto-complete="on" label-position="left">

      <div class="title-container">
        <h3 class="title">注册</h3>
      </div>

      <el-form-item prop="phone">
        <span class="svg-container">
          <i class="iconfont icon-lujing"></i>
        </span>
        <el-input
          ref="phone"
          v-model="registerData.phone"
          placeholder="手机号"
          name="phone"
          type="text"
          tabindex="1"
          auto-complete="on"
          maxlength="11"
        />
      </el-form-item>

      <el-form-item prop="verificationCode">
        <span class="svg-container">
          <i class="iconfont icon-yanzhengma"></i>
        </span>
        <el-input
          ref="verificationCode"
          v-model="registerData.verificationCode"
          placeholder="验证码"
          name="verificationCode"
          type="text"
          tabindex="1"
          auto-complete="on"
        />
        <el-button class="get-code" :disabled="disabled" type="text" @click="getCode">{{text}}</el-button>
      </el-form-item>

      <el-form-item prop="role">
        <span class="svg-container">
          <i class="iconfont icon-user1"></i>
        </span>
        <el-select v-model="registerData.type" placeholder="注册身份" style="width:100%;">
        <el-option
          v-for="item in typeList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      </el-form-item>

      <el-form-item prop="password">
        <span class="svg-container">
          <i class="iconfont icon-password"></i>
        </span>
        <el-input
          :key="passwordType"
          ref="password"
          v-model="registerData.password"
          :type="passwordType"
          placeholder="密码"
          name="password"
          tabindex="2"
          auto-complete="on"
          @keyup.enter.native="handleLogin"
        />
        <span class="show-pwd" @click="showPwd">
          <i :class="['iconfont',passwordType === 'password' ? 'icon-eye1' : 'icon-eye']"></i>
        </span>
      </el-form-item>
      <!-- 邀请码 -->
      <el-form-item prop="invitationCode">
        <span class="svg-container">
          <!-- <svg-icon icon-class="user" /> -->
          <i class="iconfont icon-yaoqing"></i>
        </span>
        <el-input
          ref="invitationCode"
          v-model="registerData.invitationCode"
          placeholder="邀请码（可不填）"
          name="invitationCode"
          type="text"
          tabindex="1"
          auto-complete="on"
        />
      </el-form-item>
      <div style="font-size: 14px;color:#fff">已有账号 <el-button type="text" @click="gotoLogin">去登录</el-button></div>
      <el-button :loading="loading" type="primary" style="width:100%;margin-bottom:30px;" @click="register">注册</el-button>
    </el-form>
  </div>
</template>

<script>
import { checkPhone } from '@/utils/tools.js'
export default {
  name: 'Login',
  data() {
    return {
      registerData: {
        phone: '',
        password: '',
        verificationCode: '',
        invitationCode:'',
        role: '',
        type:''
      },
      passwordType: '',
      loading: false,
      disabled: false,
      text: '获取验证码',
      second: 60,
      roleList: [],
      typeList: [
        {
          value: 1,
          label: '支付方',
        },
        {
          value: 2,
          label: '收款方'
        }
      ]
    }
  },
  methods: {
    showPwd() {
      if (this.passwordType === 'password') {
        this.passwordType = ''
      } else {
        this.passwordType = 'password'
      }
      this.$nextTick(() => {
        this.$refs.password.focus()
      })
    },
    handleLogin() {
      this.$router.push({ path:'/' })
    },
    // 去登录
    gotoLogin() {
      this.$router.replace({
        path: '/login'
      })
    },
    // 倒计时
    countDown() {
      this.text = this.second;
      let timer = setTimeout(()=>{
        this.second--;
        this.countDown();
      },1000)

      if(this.second==0){
        clearTimeout(timer)
        this.text = "获取验证码";
        this.disabled = false;
      }
    },
    // 获取验证码
    getCode() {
      if(!checkPhone(this.registerData.phone)){
        return false;
      }
      this.$api.getVerificationCode({
        phone: this.registerData.phone
      }).then(res => {
        if(res.data.code === 1000){
          this.$message({
          message: '发送成功',
          type: 'success'
        });
          this.disabled = true;
          this.countDown();
        }else{
          this.$message.error(res.data.msg);
        }
      })
    },
    // 获取角色列表
    getRoleList() {
      this.$api.roleList().then(res=>{
        this.roleList = res.data.data
      })
    },
    // 注册
    register() {
      if(this.registerData.verificationCode===""){
        this.$message.error('验证码不能为空');
        return false;
      }
      if(this.registerData.type===""){
        this.$message.error('请选择身份');
        return false;
      }
      if(this.registerData.password===""){
        this.$message.error('密码不能为空');
        return false;
      }else if(!/^\w{6}$/.test(this.registerData.password)){
        this.$message.error('密码必须为6位数字或字母或数字字母组合');
        return false;
      }
      // 注册
      this.$api.register({
        phone: this.registerData.phone,
        verifyCode: this.registerData.verificationCode,
        roleType: this.registerData.type,
        password: this.registerData.password,
        inviteCode: this.registerData.invitationCode
      }).then(res => {
        this.$successCallback(res,'注册成功',()=>{
          this.$router.push({
            path: '/login'
          })
        })
      })
    }
  },
  created() {
    // this.getRoleList();
  }
}
</script>

<style lang="scss">

</style>
